<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="parentx">
    <vs-sidebar
      :class="[verticalNavMenuWidth !== 'default' ? 'smallMenu' : '']"
      class="v-nav-menu items-no-padding"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe="onMenuSwipe"
    >
      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave" style="background-color: #1e0d61; height: 100%">
        <!-- Header -->
        <div class="flex items-end justify-between" slot="header">
          <!-- 사이드메뉴 상단 로고 이미지 -->
          <router-link tag="div" class="vx-logo cursor-pointer flex items-center" to="/project/2/home">
            <img class="fill-current" :src="sideTopImage" :style="sideTopImageStyle" alt="Digital SHM System" />
          </router-link>
          <!-- /Logo -->

          <!-- Menu Buttons -->
          <!-- <div> -->
            <!-- Close Button -->
            <!-- <template v-if="showCloseButton">
              <feather-icon icon="XIcon" class="m-0 cursor-pointer" @click="$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)" />
            </template> -->

            <!-- Toggle Buttons -->
            <!--            <template v-else-if="!showCloseButton && !verticalNavMenuItemsMin">-->
            <!--              <feather-icon-->
            <!--                id="btnVNavMenuMinToggler"-->
            <!--                class="mr-0 cursor-pointer"-->
            <!--                :icon="reduce ? 'CircleIcon' : 'DiscIcon'"-->
            <!--                svg-classes="stroke-current text-primary"-->
            <!--                @click="toggleReduce(!reduce)" />-->
            <!--            </template>-->
          <!-- </div> -->
          <!-- /Menu Toggle Buttons -->
        </div>
        <!-- /Header -->

        <!-- Header Shadow -->
        <!--        <div class="shadow-bottom" v-show="showShadowBottom" />-->

        <!-- Menu Search -->
        <nav-search v-if="projectId" @search="searchMenu"/>

        <!-- Menu Items -->
        <component :is="scrollbarTag" ref="verticalNavMenuPs" class="scroll-area-v-nav-menu pt-2" :settings="settings" @ps-scroll-y="psSectionScroll" @scroll="psSectionScroll" :key="$vs.rtl">
          <div ref="verticalNavMenuCt">
            <template v-for="(item, index) in menuItemsUpdated">
              <!-- Group Header -->
              <span v-if="item.header && !verticalNavMenuItemsMin" class="navigation-header truncate" style="white-space: initial !important" :key="`header-${index}`">
                {{ item.header }}
              </span>
              <!-- /Group Header -->

              <template v-else-if="!item.header">
                <!-- Nav-Item -->
                <v-nav-menu-item
                  v-if="!item.submenu"
                  :key="`item-${index}`"
                  :index="index"
                  :to="(item.url && typeof item.url === 'object') || item.single ? item.url : null"
                  :href="item.url && typeof item.url === 'string' ? item.url : null"
                  :icon="item.icon"
                  :target="isExternal(item.url) || isBlank ? '_blank' : '_self'"
                  :isDisabled="item.isDisabled"
                  :group-name="item.groupName"
                  :activeCode="item.activeCode"
                  :refMenuScroll="$refs.verticalNavMenuPs"
                  :refMenuScrollCt="$refs.verticalNavMenuCt"
                >
                  <span v-show="!verticalNavMenuItemsMin" class="truncate" style="white-space: initial !important">{{ item.name }}</span>
                  <vs-chip class="ml-auto" :color="item.tagColor" v-if="item.tag && (isMouseEnter || !reduce)">{{ item.tag }}</vs-chip>
                </v-nav-menu-item>

                <!-- Nav-Group -->
                <template v-else>
                  <v-nav-menu-group :key="`group-${index}`" :openHover="openGroupHover" :group="item" :groupIndex="index" :open="isGroupActive(item)" :refMenuScroll="$refs.verticalNavMenuPs" :refMenuScrollCt="$refs.verticalNavMenuCt" />
                </template>
                <!-- /Nav-Group -->
              </template>
            </template>
            <div style="height: 50px;"><!--Space--></div>
          </div>
        </component>
        <!-- /Menu Items -->
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div v-if="!isVerticalNavMenuActive" class="v-nav-menu-swipe-area" v-hammer:swipe="onSwipeAreaSwipe" />
    <!-- /Swipe Gesture -->
  </div>
</template>

<script>
import config from "/public/config";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VNavMenuGroup from "./VerticalNavMenuGroup.vue";
import VNavMenuItem from "./VerticalNavMenuItem.vue";

import Logo from "../Logo.vue";
import NavSearch from "@/layouts/components/vertical-nav-menu/NavSearch.vue";

export default {
  name: "v-nav-menu",
  components: {
    NavSearch,
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    Logo,
  },
  props: {
    logo: { type: String },
    openGroupHover: { type: Boolean, default: false },
    parent: { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems: { type: Array, required: true },
    title: { type: String },
  },
  data: () => ({
    sideTopImage: require('@/assets/images/logo/shm_logo_SNB.svg'),
    sideTopImageStyle: {
      width: "100%",
      height: "40px",
      margin: "20px",
    },
    hostname: config.HOST_NAME,
    clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    reduce: false, // determines if navMenu is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    settings: {
      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true,
    },
    showShadowBottom: false,
    lastScrollPosition: 0, // 마지막 스크롤 위치 저장 변수
  }),
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    isGroupActive() {
      return (item) => {
        const search = this.$store.state.menu.search;
        const path = this.$route.fullPath;
        const pathList = this.$route.path.split("/");
        const activeCode = this.$route.meta ? this.$route.meta.activeCode : undefined;
        let open = false;

        // note 옵션 체크
        try {
          const note = JSON.parse(item.note);
          if (note.onlyAdmin && !this.isAdmin) {
            return open;
          }
        } catch (e) {}

        const func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((itemSubmenu) => {

              // note 옵션 체크
              try {
                const note = JSON.parse(itemSubmenu.note);
                if (note.onlyAdmin && !this.isAdmin) {
                  return;
                }
              } catch (e) {}


              if (search) {
                open = true;
              }

              if (itemSubmenu.url
                && (path === itemSubmenu.url || (itemSubmenu.activeCode && activeCode === itemSubmenu.activeCode))) {
                open = true;
              } else if (itemSubmenu.submenu) {
                func(itemSubmenu);
              }

              if (itemSubmenu.activeCode) {
                const __index_field = pathList.indexOf('field');
                const __check_field_code = (pathList.length > __index_field + 1) ? pathList[__index_field + 1] : '_none_';
                if (`field-${__check_field_code}` === itemSubmenu.activeCode) open = true;
              }

              if (itemSubmenu.groupName) {
                itemSubmenu.groupName.map((boardId) => {
                  const __index_tab = pathList.indexOf('tab');
                  const __check_tab_code = (pathList.length > __index_tab + 1) ? pathList[__index_tab + 1] : '_none_';
                  let __check_tab_page_type = (pathList.length > __index_tab + 2) ? pathList[__index_tab + 2] : '';
                  __check_tab_page_type = __check_tab_page_type === 'write' ? '' : __check_tab_page_type;
                  const __check_board_id = `${__check_tab_code}${__check_tab_page_type ? `/${__check_tab_page_type}` : ''}`
                  if (boardId === __check_board_id) open = true;
                });
              }
            });
          }
        };
        func(item);

        return open;
      };
    },
    menuItemsUpdated() {
      let search = this.$store.state.menu.search
      search = search ? search.toLowerCase() : "";
      const func = (menu, search) => {
        if (menu.submenu) {
          const filter = menu.submenu.filter((item) => {
            if (search && item.name.toLowerCase().indexOf(search) !== -1) {
              return true;
            }
            return func(item, search);
          });
          if (filter.length > 0) {
            menu.submenu = filter;
            return true;
          }
        }
        return false;
      }

      if (search) {
        const menus = JSON.parse(JSON.stringify(this.navMenuItems));
        return menus.filter((item) => {

          if (search && item.name.toLowerCase().indexOf(search) === -1) {
            return func(item, search);
          }

          return true;
        });
      } else {
        return this.navMenuItems
      }


    },
    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.isVerticalNavMenuActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", val);
      },
    },
    layoutType() {
      return this.$store.state.mainLayoutType;
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_BUTTON", val);
      },
    },
    isVerticalNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton);
    },
    verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    postId() {
      return this.$route.params.postId;
    },
    isBlank () {
      const form = this.$store.state.menu.writeForm;
      const oldForm = this.$store.state.menu.writeOldForm;

      if (this.$route.fullPath.indexOf('write') >= 0) {
        if (this.postId && form && oldForm) {
          const objForm = JSON.parse(form);
          const objOldForm = JSON.parse(oldForm);

          if (JSON.stringify(objForm.header) === JSON.stringify(objOldForm.header)) {
            return !this.isEqual(objForm.body, objOldForm.body)
          }

          return true;
        } else {
          return true;
        }
      }
      return false
    }
  },
  watch: {
    $route() {
      if (this.isVerticalNavMenuActive && this.showCloseButton) this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
    },
    reduce(val) {
      const verticalNavMenuWidth = val ? "reduced" : this.$store.state.windowWidth < 1200 ? "no-nav-menu" : "default";
      this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);

      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    layoutType() {
      this.setVerticalNavMenuWidth();
    },
    reduceButton() {
      this.setVerticalNavMenuWidth();
    },
    windowWidth() {
      this.setVerticalNavMenuWidth();
    },
  },
  created() {
    this.loadSideTopImage().then();
    this.loadSideTopImageStyle().then();

    // localStorage에서 저장된 스크롤 위치 불러오기
    const savedScrollPosition = localStorage.getItem(`${this.hostname}_menu_scroll_position`);
    if (savedScrollPosition) {
      this.lastScrollPosition = parseInt(savedScrollPosition);
    }
  },
  methods: {
    // 빈 값 체크 함수
    isEmptyValue(value) {
      if (!value) return true; // null, undefined 제외
      if (typeof value === "string" && value.trim() === "") return true; // 빈 문자열 제외
      if (Array.isArray(value) && value.length === 0) return true; // 빈 배열 제외
      if (typeof value === "object" && Object.keys(value).length === 0) return true; // 빈 객체 제외
      return false;
    },
    // 객체 비교 함수
    isEqual(obj1, obj2) {
      // 타입이 다르면 false
      if (typeof obj1 !== typeof obj2) return false;

      // 원시 타입(숫자, 문자열, 불리언, null, undefined) 비교
      if (typeof obj1 !== "object" || obj1 === null || obj2 === null) {
        return obj1 === obj2;
      }

      // 배열 비교
      if (Array.isArray(obj1) && Array.isArray(obj2)) {
        if (obj1.length !== obj2.length) return false;
        return obj1.every((value, index) => this.isEqual(value, obj2[index]));
      }

      // 객체 비교 (빈 값 제외)
      const keys1 = Object.keys(obj1).filter(key => !this.isEmptyValue(obj1[key]));
      const keys2 = Object.keys(obj2).filter(key => !this.isEmptyValue(obj2[key]));

      // 키 개수가 다르면 false
      if (keys1.length !== keys2.length) return false;

      // 각 키의 값 비교 (재귀 호출)
      return keys1.every(key => this.isEqual(obj1[key], obj2[key]));
    },
    /**
     * 로그인 화면에서 왼편에 표시되는 이미지를 불러온다
     */
    async loadSideTopImage() {
      const cacheKey = `${this.hostname}_side_top_image`;
      const cacheExpiryKey = `${this.hostname}_side_top_image_expiry`;
      const currentTime = new Date().getTime();
      const cacheExpiry = localStorage.getItem(cacheExpiryKey);

      // 캐시가 있고 아직 만료되지 않았는지 확인
      if (localStorage.getItem(cacheKey) && cacheExpiry && currentTime < parseInt(cacheExpiry)) {
        this.sideTopImage = localStorage.getItem(cacheKey);
        return;
      }

      // 캐시가 없거나 만료된 경우 서버에서 데이터 가져오기
      const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
        key: "side_top_image",
      });

      // 데이터가 성공적으로 로드되었다면 캐시 갱신
      if (config && config.path) {
        // 24시간 후 만료시간 설정 (24 * 60 * 60 * 1000 = 86400000 밀리초)
        const expiryTime = currentTime + 86400000;

        // 캐시와 만료시간 저장
        localStorage.setItem(cacheKey, config.path);
        localStorage.setItem(cacheExpiryKey, expiryTime.toString());

        this.sideTopImage = config.path;
      }
    },
    /**
     * 사이드메뉴에 표시되는 이미지 스타일을 불러온다
     * 24시간 동안 캐싱 유지
     */
    async loadSideTopImageStyle() {
      const cacheKey = `${this.hostname}_side_top_image_style`;
      const cacheExpiryKey = `${this.hostname}_side_top_image_style_expiry`;
      const currentTime = new Date().getTime();
      const cacheExpiry = localStorage.getItem(cacheExpiryKey);

      // 캐시가 있고 아직 만료되지 않았는지 확인
      if (localStorage.getItem(cacheKey) && cacheExpiry && currentTime < parseInt(cacheExpiry)) {
        this.sideTopImageStyle = JSON.parse(localStorage.getItem(cacheKey));
        return;
      }

      // 캐시가 없거나 만료된 경우 서버에서 데이터 가져오기
      const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
        key: "side_top_image_style",
      });

      // 데이터가 성공적으로 로드되었다면 캐시 갱신
      if (config && config.width) {
        // 24시간 후 만료시간 설정 (24 * 60 * 60 * 1000 = 86400000 밀리초)
        const expiryTime = currentTime + 86400000;

        // 캐시와 만료시간 저장
        localStorage.setItem(cacheKey, JSON.stringify(config));
        localStorage.setItem(cacheExpiryKey, expiryTime.toString());

        this.sideTopImageStyle = config;
      }
    },

    onMenuSwipe(event) {
      if (event.direction === 4 && this.$vs.rtl) {
        // Swipe Right
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false;
      } else if (event.direction === 2 && !this.$vs.rtl) {
        // Swipe Left
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false;
      }
    },
    onSwipeAreaSwipe(event) {
      if (event.direction === 4 && !this.$vs.rtl) {
        // Swipe Right
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true;
      } else if (event.direction === 2 && this.$vs.rtl) {
        // Swipe Left
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true;
      }
    },
    psSectionScroll() {
      const scroll_el = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs;
      this.showShadowBottom = scroll_el.scrollTop > 0;

      // 스크롤 위치 저장
      this.lastScrollPosition = scroll_el.scrollTop;
      localStorage.setItem(`${this.hostname}_menu_scroll_position`, scroll_el.scrollTop);
    },
    mouseEnter() {
      if (this.reduce) this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);
      this.isMouseEnter = true;
    },
    mouseLeave() {
      if (this.reduce) this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", true);
      this.isMouseEnter = false;
    },
    setVerticalNavMenuWidth() {
      if (this.windowWidth > 1200) {
        if (this.layoutType === "vertical") {
          // Set reduce
          this.reduce = !!this.reduceButton;

          // Open NavMenu
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin = !!(this.reduceButton && !this.isMouseEnter);
          this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", verticalNavMenuItemsMin);

          // Menu Action buttons
          this.clickNotClose = true;
          this.showCloseButton = false;

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced ? "reduced" : "default";
          this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);

          return;
        }
      }

      // Close NavMenu
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);

      // Reduce button
      if (this.reduceButton) this.reduce = false;

      // Menu Action buttons
      this.showCloseButton = true;
      this.clickNotClose = false;

      // Update NavMenu Width
      this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");

      // Remove Only Icon in Menu
      this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);
    },
    toggleReduce(val) {
      this.reduceButton = val;
      this.setVerticalNavMenuWidth();
    },

    // groupItem.slug 설정과 상관없이 url이 http, https로 시작하는 경우 외부 링크로 연결해주기 위함.
    isExternal(url) {
      return typeof url === "string" && (url.indexOf("http") === 0 || url.indexOf("https") === 0);
    },

    searchMenu(value) {
      this.$store.commit("menu/SEARCH_MENU", value);
    },
  },
  mounted() {
    this.setVerticalNavMenuWidth();

    // DOM이 렌더링된 후 스크롤 위치 복원
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.verticalNavMenuPs) {
          const scroll_el = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs;
          if (scroll_el && this.lastScrollPosition) {
            scroll_el.scrollTop = this.lastScrollPosition;
            // console.log('스크롤 위치 복원:', this.lastScrollPosition);
          }
        }
      }, 100); // 약간의 지연 시간을 두어 DOM이 완전히 렌더링될 시간을 줍니다
    });
  },
  updated() {
    // 컴포넌트가 업데이트된 후 스크롤 위치 복원
    this.$nextTick(() => {
      if (this.$refs.verticalNavMenuPs) {
        const scroll_el = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs;
        if (scroll_el && this.lastScrollPosition) {
          scroll_el.scrollTop = this.lastScrollPosition;
        }
      }
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss";

.smallMenu {
  .vs-sidebar {
    max-width: 70%;
  }
}
</style>
